module.exports = __webpack_public_path__ + "static/media/BannerSeguimiento.bb04e8ed.svg";